import { gql } from '@apollo/client';

export const GET_ERROR_DATA = gql`
  {
    getErrorData @client {
      isGraphQLError
      isNetworkError
    }
  }
`;
